/* eslint-disable */
import displayMixin from './_mixin_display_base.js'
import {Field as VField} from "vee-validate";
import { useFormResultStore, answerKey } from '../../stores/form_result';
import errors from './_errors.vue';
import {SIGNAL_SOURCE} from '../../../../assets/angular/channels/form_result';

export default {
  components: {VField, errors},
  mixins: [displayMixin],
  inject: {
    routeParams: {},
    onUpdate: {},
    formResultData: {},
    formResult: {},
    luaErrors: { default: ()=>({}) },
  },
  skipDisplayCreate: true,
  data: ()=>({
    answerKey,
  }),
  computed:{
    field_id(){ return this.field.id}, // for parallel editing
    isValidComputed(){ return true }, // globally is always true
    classes(){
      return {
        'ng-valid': this.answered && (this.isValidComputed !== false),
        'ng-invalid': this.required || (this.isValidComputed === false)
      }
    },
    isInvalid(){ return this.required || (this.isValidComputed === false)},
    answered(){ return (this.answer.data.value||'').length > 0 },
    required(){
      return this.field.datahash.required && !this.answered
    },
  },
  created () {
    this.setBasicAnswer()
    this.setValidity && this.setValidity()
  },
  mounted(){
    // need on mounted form to run validate
    if (this.onUpdate) this.onUpdate(this.field, 'mount')
    else console.log("not found onUpdate", this.$options.__file, this)
  },
  methods:{
    basicAnswerInit(field, not_used_option_index) {
      // try to get a previous answer to this question in this form
      let answer = this.initializeAnswer(field, {
        option_id: 0
      });

      return this.formResultStore.addAnswer(answer);
    },
    cleanUpAnswer(attr = 'value'){
      const value = this.answer.data[attr]
      if (value) this.answer.data[attr] = value.trim()
    },
    setupFormResultStorage(){
      this.formResultStore = useFormResultStore(this.form_result)
      this.formResultStore.$onAction(({
                                        name, // name of the action
                                        store, // store instance, same as `someStore`
                                        args, // array of parameters passed to the action
                                        after, // hook after the action returns or resolves
                                      })=>{
        // catching ONLY current answer updates
        if (name !== 'addAnswer') return
        if (answerKey(args[0]) !== answerKey(this.answer)) return;

        const old_str = JSON.stringify(store.getAnswer(this.answer))
        after((result)=>{
          this.answer = result
          if (JSON.stringify(result) === old_str){

            const signalSource = args[1]
            if (signalSource === SIGNAL_SOURCE)  this.onAnswerChange && this.onAnswerChange()
            return
          }else{
            // this.answer = result
            this.onAnswerChange && this.onAnswerChange()
          }
        })
      })
    },
    onAnswerChange(){
      //prototype
    },
  }
}